<div class="container-fluid">
	<div class="row flex-nowrap">

		<div id="menu-panel" class="col-auto d-none d-md-block">

			<div class="menu-header text-center">
				<i class="fa fa-4x fa-building page-icon"></i>
			</div>

			<div>
				<div class="text-center">LISTA</div>
				<button id="filter-btn" class="btn btn-dark pl-3 pr-3 mb-2 disabled"><i class="fa fa-lg mb-2 fa-search"></i><br />Szűrő</button><br />
				<button class="btn btn-primary pl-3 pr-3" onclick="Anvil.page.refresh()"><i class="fa fa-lg mb-2 fa-sync-alt"></i><br />Frissítés</button>
				<!--
				<hr />
				<div class="text-center">ADATOK</div>
				<div class="btn-group-vertical">
					<button class="btn btn-success pl-3 pr-3"><i class="fa fa-lg mb-2 fa-file-import"></i><br />Importálás</button>
					<button class="btn btn-success pl-3 pr-3"><i class="fa fa-lg mb-2 fa-file-export"></i><br />Exportálás</button>
				</div>
				-->
			</div>
		</div>

		<div class="col list-panel">

			<div class="row">
				<div class="col">

					<div class="page-header">

						<div class="float-end pt-4" style="width:300px; max-width:50vw;">
							<div class="input-group">
								<input type="text" class="form-control" id="status-search" placeholder="Keresés..." oninput="Anvil.page.quickSearch($(this).val())" />
								<span class="input-group-text"><i class="fa fa-search"></i></span>
							</div>
						</div>

						<h2>Cégek</h2>
						<ol class="breadcrumb">
							<li class="breadcrumb-item"><a href="/home"><i class="fa fa-home"></i></a></li>
							<li class="breadcrumb-item">Partnerek</li>
							<li class="breadcrumb-item active">Cégek</li>
						</ol>
					</div>

					<%- include('/ui/grid', {
						name: 'company',
						params: {
							row_height: 48,
							columns: [
								{
									title: 'ID',
									field: 'id',
									type: {
										render (value, row) {
											return `<strong ${(!row.uuid ? 'class="text-warning"' : '')}>${value}</strong>`
										}
									},
									width: 60
								},
								{
									title: 'Adószám',
									field: 'tax_number',
									type: 'string',
									width: 120
								},
								{
									title: 'Név',
									field: 'name',
									type: {
										render (value, row, options) {
											var group = null
											if (row.group_id) {
												const company_group = Anvil.page.company_groups.getById(row.group_id)
												if (company_group != undefined) {
													group = company_group.name
												}
											}

											var dist = null
											if (row.distributor_id) {
												const distributor = Anvil.page.companies.getById(row.distributor_id)
												if (distributor != undefined) {
													dist = distributor.name
												}
											}

											var ref = null
											if (row.referer_id) {
												const referer = Anvil.page.companies.getById(row.referer_id)
												if (referer != undefined) {
													ref = referer.name
												}
											}

											return `
												<strong>${value}</strong><br />
												<div class="float-end">
													${(row.service_partner ? '<div class="badge bg-warning">Pénztárgép szervíz</div>' : '')}
													${(row.referer ? '<div class="badge bg-success">Ajánló</div>' : '')}
													${(row.distributor ? '<div class="badge bg-primary">Disztribútor</div>' : '')}
												</div>
												${row.distributor_id ? `<div class="badge bg-dark ${row.distributor_id == 145 ? 'text-primary' : 'text-warning'} c_info" title="Disztibútor: ${dist}"><strong>${dist.substring(0, 3).toUpperCase()}</strong></div>` : ''}
												${row.referer_id ? `<div class="badge bg-success c_info" title="Ajánló: ${ref}"><strong>${ref.substring(0, 3).toUpperCase()}</strong></div>` : ''}
												${group ? `<div class="badge bg-dark text-dim">${group}</div>` : ''}
												`
										}
									},
									options: {
										cutoff: 40
									},
									width: 320
								},
								{
									title: 'Székhely',
									value: (value, row) => {
										return `${row.invoice_area_code} ${row.invoice_city}` + (row.invoice_address ? `, ${row.invoice_address}` : '')
									},
									type: {
										render (value, row, options) {
											return `${row.invoice_city}` + (row.invoice_address ? `,<br /><small class="text-secondary">${row.invoice_address}</small>` : '')
										}
									},
									options: {
										cutoff: 40
									},
									width: 260
								},
								/*
								{
									title: 'Címkék',
									field: 'tags',
									type: {
										render (value) {
											const tags = []
											for (const tag_id of value) {
												const tag = Anvil.page.company_tags.getById(tag_id)
												if (tag != undefined) {
													tags.push(tag)
												}
											}
											return tags.map(t => `<span class="badge bg-secondary">${t.name}</span>`).join(' ')
										}
									},
									width: 400
								},
								*/
								{
									title: 'Bevétel',
									field: 'invoice_total',
									type: {
										render (value, row) {
											return `
											<small>
												<span class="float-start">Sz.:</span> <strong style="color:goldenrod;">${Anvil.numeral(row.invoice_total || 0).format('0,0')}</strong><br />
												<span class="float-start">F.:</span> <strong style="color:goldenrod;">${Anvil.numeral(row.transaction_total_incoming).format('0,0')}</strong>
											</small>
											`
										}
									},
									options: {
										class: 'text-end'
									},
									width: 120
								},
								{
									title: 'Kiadás',
									field: 'supplier_invoice_total',
									type: {
										render (value, row) {
											return `
											<small>
												<span class="float-start">Sz.:</span> <strong style="color:peru;">${Anvil.numeral(row.supplier_invoice_total || 0).format('0,0')}</strong><br />
												<span class="float-start">F.:</span> <strong style="color:peru;">${Anvil.numeral(row.transaction_total_outgoing).format('0,0')}</strong>
											</small>
											`
										}
									},
									options: {
										class: 'text-end'
									},
									width: 120
								},
								{
									title: 'Egyenleg',
									field: '',
									value: (v, row) => {
										const invoice_sum = (row.invoice_total || 0) + (row.supplier_invoice_total || 0)
										const transaction_sum = (row.transaction_total_incoming || 0) + (row.transaction_total_outgoing || 0)
										return -invoice_sum + transaction_sum
									},
									type: {
										render (value, row) {
											return `<strong class="${value >= 0 ? 'text-success' : 'text-warning'}">${Anvil.numeral(value).format('0,0')}</strong>`
										}
									},
									options: {
										class: 'text-end'
									},
									width: 120
								}
								/*
								{
									title: 'Adatbázisok',
									field: 'id',
									value: (v) => {
										return Anvil.page.company_dbs.data.filter(x => x.company_id == v).reduce((a, b) => a + b.db_name + ', ', '').slice(0, -2)
									},
									type: 'string',
									options: {
										cutoff: 60
									},
									width: 400
								}
								*/
							]
						},
						list: companies
					}) %>
				</div>
			</div>

			<div class="py-3">
				<button onclick="history.back()" class="btn btn-dark"><i class="fa fa-angle-left me-2"></i>Vissza</button>
				<div class="float-end">
					<div class="btn-group">
						<button class="btn btn-success" onclick="Anvil.page.new()"><i class="fa fa-fw fa-plus"></i><span class="d-none d-md-inline ms-2">Új cég</span></button>
						<button class="btn btn-success" onclick="Anvil.page.copy()"><i class="fa fa-fw fa-copy"></i><span class="d-none d-md-inline ms-2">Cég másolása</span></button>
					</div>
					<button class="btn btn-primary ml-2" onclick="Anvil.page.open()"><i class="fa fa-fw fa-edit"></i><span class="d-none d-md-inline ms-2">Megnyitás</span></button>
					<button class="btn btn-danger ml-2" onclick="Anvil.page.delete()"><i class="fa fa-fw fa-trash"></i><span class="d-none d-md-inline ms-2">Törlés</span></button>
				</div>
			</div>

		</div>

	</div>
</div>

<script>
Object.assign(Anvil.page, {

	quickSearch (expression) {
		Anvil.models.components.Grid.find('#company_grid').filter(expression)
	},

	refresh () {
		Anvil.exec('company/action_refresh')
	},

	new () {
		Anvil.exec('company/modal_edit')
	},

	open () {
		let sel = Anvil.models.components.Grid.find('#company_grid').selected_rows
		if (sel.length > 0) {
			Anvil.exec('company/modal_edit', sel[0].id)
		}
	},

	delete () {
		let sel = Anvil.models.components.Grid.find('#company_grid').selected_rows
		if (sel.length > 0) {
			Anvil.exec('company/action_delete', sel[0].id)
		}
	},

	invoicing (company_id) {
		Anvil.exec('company/modal_invoicing', company_id)
	},
})

$('#company_grid').on('dblclick', 'tbody tr', function () {
	Anvil.page.open()
})
</script>
